import { render, staticRenderFns } from "./AccountingTransactionForm.vue?vue&type=template&id=47462cc9&"
import script from "./AccountingTransactionForm.vue?vue&type=script&lang=js&"
export * from "./AccountingTransactionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports